import {useMemo} from 'react'

import {useTimer} from 'use-timer'

const useTimerString = (isSignup) => {
    const {time, start, reset} = useTimer({
        initialTime: 20,
        endTime: 0,
        timerType: 'DECREMENTAL',
        autostart: true,
    })

    const timeStr = useMemo(() => {
        const zeroPad = time >= 10 ? '' : '0'
        return `00:${zeroPad}${time}`
    }, [time])

    return {
        startTime: start,
        resetTime: () => {
            reset()
            start()
        },
        timeStr,
    }
}

export default useTimerString
